import { TrialAnswer } from '@/api/apis/case';

export const TRIAL_PARTICIPATION_OPTIONS = [
  { value: 'true', name: 'Yes' },
  { value: 'false', name: 'No' },
];

export const TRIAL_SCENARIO_OPTIONS = [
  { value: TrialAnswer.PartA, name: 'Part A (single arm)' },
  { value: TrialAnswer.PartB, name: 'Part B (randomized)' },
];

export const HEART_COLD_STORAGE_OPTIONS = [
  { value: TrialAnswer.SherpaPak, name: 'SherpaPak' },
  { value: TrialAnswer.IceCooler, name: 'Ice cooler' },
  { value: TrialAnswer.Other, name: 'Other' },
];

export const LUNGS_COLD_STORAGE_OPTIONS = [
  { value: TrialAnswer.LUNGGuard, name: 'LUNGGuard' },
  { value: TrialAnswer.BAROGuard, name: 'BAROGuard' },
  { value: TrialAnswer.StandardColdPreservation, name: 'Standard Cold Preservation' },
  { value: TrialAnswer.Other, name: 'Other' },
];
